const getters = {
    getOnlinePointData(state) {
        let online_names = state.online_names
        return state.pointData.filter(function (x) {
            for(let i in online_names){
                if(x.name===online_names[i]){
                    return 1
                }
            }
            return 0

        })
    },

    getOnlinePointCoor(state) {
        let online_names = state.online_names

        let res = {}
        for(let i in online_names){
            res[online_names[i]] = state.pointCoor[online_names[i]]
        }
        return res
    },

    getOfflinePointData(state) {
        let offline_names = state.offline_names
        return state.pointData.filter(function (x) {
            for(let i in offline_names){
                if(x.name===offline_names[i]){
                    return 1
                }
            }
            return 0
        })
    },

    getOfflinePointCoor(state) {
        let offline_names = state.offline_names
        let res = {}
        for(let i in offline_names){
            res[offline_names[i]] = state.pointCoor[offline_names[i]]
        }
        return res
    },
    // [{name: 'esp0001',online: true,latitude: 39.92,longitude: 116.46,},]
    getNodes(state) {
        let nodes = []
        let oname
        let fname
        for( let i in state.online_names) {
            oname = state.online_names[i]
            nodes.push({'name': oname, 'online': true,
                'latitude': state.pointCoor[oname][1],
                'longitude': state.pointCoor[oname][0],
                'nick_name': state.nodes.find(e=>e.value===oname).nick_name})
        }

        for( let j in state.offline_names) {
            fname = state.offline_names[j]
            nodes.push({'name': fname, 'online': false,
                'latitude': state.pointCoor[fname][1],
                'longitude': state.pointCoor[fname][0],
                'nick_name': state.nodes.find(e=>e.value===fname).nick_name})
        }
        return nodes
    },
    // 获取默认单位
    getDefaultUnit(state) {
        return (name) => {
            const node_info = state.nodes.find(node => node.label === name)
            // 0 加速度 1 速度 2 位移
            const unit = node_info && node_info.unit !== undefined ? node_info.unit : 1
            return unit
        }
    },
    getSensitivity(state) {
        return (name, dir)=>{
            const node_info = state.nodes.find(node => node.label === name)
            if(dir==='x') {
                return node_info.sensitivity_x
            } else if(dir==='y') {
                return node_info.sensitivity_y
            } else if(dir==='z') {
                return node_info.sensitivity_z
            } else {
                return node_info.sensitivity_x
            }
        }
    },
    getConstant(state) {
        return (name, dir)=>{
            const node_info = state.nodes.find(node => node.label === name)
            if(dir==='x') {
                return node_info.constant_x
            } else if(dir==='y') {
                return node_info.constant_y
            } else if(dir==='z') {
                return node_info.constant_z
            } else {
                return node_info.constant_x
            }
        }
    },
    getGeoParams(state) {
        return state.geo_params
    }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js